import React from 'react';
import {Button} from '@material-ui/core' ;
import DeleteIcon from '@material-ui/icons/Delete'
import GridListTile from '@material-ui/core/GridListTile';
import './card.css';
import Form from './Form';

const Card = ({ note1, text, note, setNote, key }) => {
    const click = () => alert('Delete'); 
    const deleteHandler = (e) =>{
        setNote(note.filter( (el) => el.id !== note1.id ));
    }
    return(
        <div className="card-container">
            <div className="card">
                <p className="text">{text}</p>
            </div>
            <div className="btnHolder">
                <Button 
                    id="btn" 
                    variant="contained" 
                    endIcon={<DeleteIcon />} 
                    color="secondary" 
                    onClick={deleteHandler}>
                        Delete note 
                </Button>
            </div>
        </div>
        
    );   
}

export default Card;